import React from 'react';
import { motion } from 'framer-motion';
import { PricingCards } from './PricingCards';
export function PricingSection() {
  return <section id="elegi-tu-plan" className="py-24 md:py-32 px-4 bg-bg-primary scroll-mt-16" data-id="element-193">
      <div className="max-w-6xl mx-auto" data-id="element-194">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-text-primary font-display font-bold text-3xl md:text-5xl mb-4 text-center" data-id="element-195">
          ELEGÍ TU PLAN
        </motion.h2>
        <div className="w-12 h-[3px] bg-gold-primary rounded-sm mx-auto mb-16" data-id="element-196" />
        <PricingCards data-id="element-197" />
      </div>
    </section>;
}